/** Concatenates displayable matrix fields for the Content Map panel. */
export function contentMapBody(
  content: Record<string, unknown> | null | undefined
): string {
  if (!content) return ""
  return [
    content.contentHeading,
    content.contentIntro,
    content.contentBody,
    content.contentFooter,
    content.valOne,
    content.valTwo,
    content.valThree,
    content.valFour,
    content.valFive,
  ]
    .filter(Boolean)
    .join(" ")
}
